import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private logoutSubject = new Subject<void>();

  get logout$() {
    return this.logoutSubject.asObservable();
  }

  emitLogout() {
    this.logoutSubject.next();
  }
}
